import React, { useEffect } from "react";
import BHARATSINH from "../IMG/Leaders/BHARATSINH.svg"
import MEHUL from "../IMG/Leaders/MEHUL.svg"
import HITESHKHERADIYA from "../IMG/Leaders/HITESHKHERADIYA.svg"
import PRATIKSIR from "../IMG/Leaders/PRATIKSIR.svg"
import PARULPANDYA from "../IMG/Leaders/PARULPANDYA.svg"
import DARSHNAPANDYA from "../IMG/Leaders/DARSHNAPANDYA.svg"
import MITSUMAM from "../IMG/Leaders/MITSUMAM.svg"
import PIYUSHPANDYA from "../IMG/Leaders/PIYUSHPANDYA.svg"

import WhatsAppBtnn from ".///../IMG/WhatsAppBtnn.png"

function Team() {

  return (
    <div style={{background: "#dcfcf4 "}} >
      {/* <!-- Back to Top --> */}
    <a href="#" class="btn btn-lg btn-dark btn-lg-square back-to-top">
        <i class="bi bi-arrow-up"></i>
        </a>
      <div className="container-xxl py-5" >
        <div className="container" >
          <div className="text-center mx-auto" style={{ maxWidth: 500 }}>
            <h1 className="display-6 mb-5">
              Meet Our Professional Team Members
            </h1>
          </div>
          <div className="row g-4" >
            <div
              className="col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={PIYUSHPANDYA} alt />
                <div className="text-center p-4">
                  <h5>Piyush Pandya</h5>
                  <span>Founder President And MD</span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Piyush Pandya</h5>
                  <p>Founder President And MD</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square m-1"
                      href="https://www.instagram.com/piyushpandya4265/"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.facebook.com/piyush.pandya.372"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://in.linkedin.com/in/piyush-pandya-303b46246"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 col-md-6 wow fadeInUp "
              data-wow-delay="0.3s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={MEHUL} alt />
                <div className="text-center p-4">
                  <h5>Mehul Pradhan</h5>
                  <span>SME-Retail Head</span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Mehul Pradhan</h5>
                  <p>SME-Retail Head</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.instagram.com/m_pradhan22/?hl=en"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.facebook.com/mehul.pradhan.1"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.linkedin.com/in/mehul-pradhan-13804325/"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={PARULPANDYA} alt />
                <div className="text-center p-4">
                  <h5>Parul Pandya</h5>
                  <span>Director</span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Parul Pandya</h5>
                  <p>Director</p>
                  <div className="d-flex justify-content-center">
                    <a className="btn btn-square btn-light m-1" 
                    href="https://www.instagram.com/primewealthcare_imf/"
                    target="_blank">
                     <i className="fab fa-instagram" />
                    </a>
                    <a className="btn btn-square btn-light m-1"
                    href="https://www.facebook.com/primewealthcaresolution/"
                    target="_blank"
                    >
                     <i className="fab fa-facebook-f" />
                    </a>
                    <a className="btn btn-square btn-light m-1"
                     href="https://www.linkedin.com/company/prime-wealthcare-solution-pvt-ltd/"
                     target="_blank"
                     >
                     <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.7s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={MITSUMAM} alt />
                <div className="text-center p-4">
                  <h5>Mitsu Pandya</h5>
                  <span> Principal Officer </span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Mitsu Pandya</h5>
                  <p>Principal Officer</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.instagram.com/mitsuoffical_prime/profilecard/?igsh=MXB5N3B2YzhqazdmcQ=="
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.facebook.com/share/1CaUz1VnjZ/?mibextid=LQQJ4d"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.linkedin.com/in/mitsu-pandya-304390290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.7s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={ DARSHNAPANDYA} alt />
                <div className="text-center p-4">
                  <h5>Darshana Pandya</h5>
                  <span> Director </span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Darshana Pandya</h5>
                  <p>Director</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.instagram.com/primewealthcare_imf/"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.facebook.com/primewealthcaresolution/"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.linkedin.com/company/prime-wealthcare-solution-pvt-ltd/"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
           
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.7s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={BHARATSINH} alt />
                <div className="text-center p-4">
                  <h5>Bharatsinh Solanki</h5>
                  <span> Assistant Director <br /> (Bhavnagar/Rajkot) </span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Bharatsinh Solanki</h5>
                  <p>Assistant Director <br /> (Bhavnagar/ Rajkot)</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.instagram.com/bharatsinhji8080/profilecard/?igsh=MTB1bTQyNDczZW05dw== "
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.facebook.com/share/MtUKF6fpCgdLBp25/"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.linkedin.com/in/bharatsinh-solanki-a405b7226?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.7s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={HITESHKHERADIYA} alt />
                <div className="text-center p-4">
                  <h5>Hitesh Kheradiya</h5>
                  <span> Assistant Director <br /> (Surat) </span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Hitesh Kheradiya </h5>
                  <p>Assistant Director <br /> (Surat)</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.instagram.com/hiteshrajput_2222/profilecard/?igsh=MWEyOWNyc3l0MXM1MQ=="
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.facebook.com/share/1EHa9kdLCe/"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f"/>
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.linkedin.com/in/kheradiya-hitesh-469311316?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in"/>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.7s"
            >
              <div className="team-item rounded">
                <img className="img-fluid" src={PRATIKSIR} alt />
                <div className="text-center p-4">
                  <h5>Pratik Barot</h5>
                  <span>  Assistant Director <br /> (Ahmedabad/Vadodara) </span>
                </div>
                <div
                  style={{ background: "#dcfcf4" }}
                  className="team-text text-center p-4"
                >
                  <h5>Pratik Barot</h5>
                  <p> Assistant Director <br /> (Ahmedabad/Vadodara)</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.instagram.com/pratik_barot7?igsh=ZzZic3ZyeDc4cDky&utm_source=qr"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.facebook.com/share/18nc2zvJp9/?mibextid=wwXIfr"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-square btn-light m-1"
                      href="https://www.linkedin.com/in/pratik-barot-a0666530a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
      {/* Live WhatsApp Chat start  */}
    <div className="livechat">
        <a 
          aria-label="Chat on WhatsApp" 
                                                                                                                                                                                                                                                                                                                href="https://wa.me/919725655005?text= hello, I have a question "   

          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="Chat on WhatsApp" src={WhatsAppBtnn} className="whatsapp-icon" />
        </a>
    </div>
      
      
    </div>
  );
}

export default Team;
